export default __webpack_public_path__ + "static/media/inspector-bitmap-layer.6139edf7.svg";